/** @jsxImportSource @emotion/react */
import { Typography, Paper } from "@mui/material";
import { styles } from "./styles";

interface Props {}
export const ContactUs: React.FC<Props> = () => {
  return (
    <div css={styles.container}>
      <Typography color="primary" css={styles.text}>
        Contact Information
      </Typography>

      <Typography color="primary" css={styles.address}>
        2335 Soquel Drive unit F
      </Typography>
      <Typography color="primary" css={styles.city}>
        Santa Cruz CA 95065
      </Typography>
      <Typography color="primary" css={styles.phone}>
        <a href="tel:8314601200"> (831) 460-1200</a>
      </Typography>
      <div>
        <Typography color="primary" css={styles.byApp}>
          Please note: We are a "by appointment only" company. Please call or
          text us to schedule service.
        </Typography>
        <Typography color="primary" css={styles.byApp}></Typography>
      </div>
      <div>
        <Typography color="primary" css={styles.hourheadng}>
          Hours
        </Typography>
        <Typography color="primary" css={styles.hours}>
          Mon-Fri: 8:00am - 5:30pm
        </Typography>
        <Typography color="primary" css={styles.hours}>
          Saturday: By appointment
        </Typography>
      </div>
      <div css={styles.imgContainer}>
        <img src="/images/map.jpg" alt="map" css={styles.img} />
      </div>
    </div>
  );
};
